<template>
  <div class="article_card">
    <el-row>
      <el-carousel type="card" height="400px" :autoplay="false">
        <el-carousel-item v-for="item in expertList" :key="item.expertId">
          <el-card>
            <div class="card_button_control">
              <el-button type="text" @click="getExpertById(item.expertId,'查看')">查看</el-button>
              <el-button type="text" @click="getExpertById(item.expertId,'编辑')">编辑</el-button>
              <el-button type="text" @click="deleteExpert(item.expertId)">删除</el-button>
            </div>
            <el-row>
              <el-col :span="12">
                <el-row>
                  <img
                    :src="item.expertImg?item.expertImg:'/static/img/common/zwtp.png'"
                    class="image"
                    onerror="this.src='/static/img/common/zwtp.png'"
                  />
                </el-row>
                <el-row>
                  <h2 class="card_h2">{{`${item.expertName}${item.expertHonor}`}}</h2>
                </el-row>
              </el-col>
              <el-col :span="12" class="card_article_body">
                <p class="card_article_body_title">
                  <span>院士简介:</span>
                </p>
                <p class="card_article_body_content" v-html="item.expertText"></p>
              </el-col>
            </el-row>
          </el-card>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <div class="page-panel__footer">
      <el-pagination
        :current-page.sync="search.pageNo"
        :page-size="search.pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog :title="addMemberTitle" :visible.sync="dialogVisable.memberDialog" width="40%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th>
              <span class="required_column">*</span>会员姓名
            </th>
            <td>
              <el-input placeholder="请输入会员姓名" v-model="memberParam.expertName"></el-input>
            </td>
          </tr>
          <tr>
            <th>荣誉</th>
            <td>
              <el-input placeholder="请输入会员所获得的最高荣誉" v-model="memberParam.expertHonor"></el-input>
            </td>
          </tr>
          <tr>
            <th>专家排序</th>
            <td>
              <el-input placeholder="请输入排序序号" v-model="memberParam.expertSort" type="number"></el-input>
            </td>
          </tr>
          <tr>
            <th>是否推荐</th>
            <td>
              <el-radio-group v-model="memberParam.expertRecommend">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th>
              <span class="required_column">*</span>会员照片
            </th>
            <td>
              <el-upload
                class="avatar-uploader"
                action="/file/upload"
                :show-file-list="false"
                :on-success="uploadSuccess"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
          <tr>
            <th>专家简介</th>
            <td>
              <ueditor :config="editorConfig" v-model="memberParam.expertText"></ueditor>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable.memberDialog= false">取消</el-button>
        <el-button type="primary" @click="updateMember">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看专家委员会成员信息" :visible.sync="dialogVisable.memberDetailDialog" width="30%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th>会员姓名</th>
            <td>{{memberParam.expertName}}</td>
          </tr>
          <tr>
            <th>荣誉</th>
            <td>{{memberParam.expertHonor}}</td>
          </tr>
          <tr>
            <th>专家简介</th>
            <td>
              <p v-html="memberParam.expertText"></p>
            </td>
          </tr>
          <tr>
            <th>专家排序</th>
            <td>{{memberParam.expertSort}}</td>
          </tr>
          <tr>
            <th>是否推荐</th>
            <td>
              <el-radio-group v-model="memberParam.expertRecommend" disabled>
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th>会员照片</th>
            <td>
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable.memberDialog= false">取消</el-button>
        <el-button type="primary" @click="updateMember">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
// 测试
import * as userCenterApi from '@/api/userCenter';
export default {
  data () {
    return {
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      addMemberTitle: '新增专家委员会成员',
      dialogVisable: { memberDialog: false, memberDetailDialog: false },
      memberParam: {
        expertRecommend: 0
      },
      imageUrl: '',
      total: 6,
      expertList: [],
      search: {
        pageNo: 1,
        pageSize: 6
      }
    };
  },
  methods: {
    checkInfo (info) {
      if (!info.expertName) {
        this.$notify({
          title: '警告',
          message: '请输入专家姓名',
          type: 'warning'
        });
        return false;
      } else if (info.expertName.length > 20) {
        this.$notify({
          title: '警告',
          message: '姓名字数不能超过20',
          type: 'warning'
        });
        return false;
      } else if (!info.expertImg) {
        this.$notify({
          title: '警告',
          message: '请选择专家图片',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    deleteExpert (id) {
      this.$confirm('是否删除该专家委员会成员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userCenterApi.deleteExpert({ expertId: id }).then(res => {
            this.getExpertList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    updateMember () {
      if (this.checkInfo(this.memberParam)) {
        if (this.memberParam.expertId) {
          userCenterApi.updateExpertById(this.memberParam).then(res => {
            this.initDialog();
          });
        } else {
          userCenterApi.addExpert(this.memberParam).then(res => {
            this.initDialog();
          });
        }
      }
    },
    getExpertById (id, operate) {
      userCenterApi.getExpertById({ expertId: id }).then(res => {
        this.memberParam = res.data;
        this.imageUrl = this.memberParam.expertImg;
        if (operate === '查看') {
          this.dialogVisable.memberDetailDialog = true;
        } else {
          this.addMemberTitle = '编辑专家委员会成员信息';
          this.dialogVisable.memberDialog = true;
        }
      });
    },
    initDialog () {
      this.getExpertList();
      this.imageUrl = '';
      this.memberParam = {
        expertRecommend: 0
      };
      this.dialogVisable.memberDialog = false;
    },
    openDialog () {
      this.dialogVisable.memberDialog = true;
      this.addMemberTitle = '新增专家委员会成员信息';
      this.memberParam = {
        expertRecommend: 0
      };
      this.imageUrl = '';
    },
    uploadSuccess (res, file, fileList) {
      this.memberParam.expertImg = res.url;
      this.imageUrl = res.url;
    },
    getExpertList () {
      userCenterApi.getExpertList(this.search).then(res => {
        this.expertList = res.data.list;
        this.total = res.data.totalCount;
      });
    }
  },
  mounted () {
    this.getExpertList();
  }
};
</script>

<style lang="stylus" scoped>
.card_button_control {
  text-align: right;
}

.card_h2 {
  text-align: center;
}

.article_card {
  .image {
    width: 100%;
  }

  .el-carousel__item {
    .el-card.is-always-shadow {
      opacity: 0.4;
    }
  }

  .el-carousel__item.is-active {
    .el-card.is-always-shadow {
      opacity: 2;
    }
  }

  .card_article_body {
    padding-left: 2px;

    .card_article_body_title {
      font-size: 14px;
    }

    .card_article_body_content {
      text-indent: 2em;
      max-height: 240px;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/userCenter/expert.vue